export default "__VITE_ASSET__DHmHX9ZN__"